import { InputProps, InputRef } from 'antd'
import { useCustomInput } from 'shared/libs/hooks/useCustomInput'

import { useRef } from 'react'

import CustomInput from 'shared/ui/Form/CustomInput/CustomInput'
import PasswordFiled from 'shared/ui/Form/PasswordFiled'

import './CustomPasswordFiled.css'

type Props = InputProps & {
  wrapperClassname?: string
  placeholderClassname?: string
}

const CustomPasswordFiled = ({
  placeholder,
  className,
  wrapperClassname,
  placeholderClassname,
  value,
  ...props
}: Props) => {
  const inputRef = useRef<InputRef>(null)
  const { isFocus, setIsFocus, handleBlur, handleFocus } = useCustomInput()
  return (
    <CustomInput
      placeholder={placeholder}
      childrenRef={inputRef}
      value={value}
      wrapperClassname={wrapperClassname}
      placeholderClassname={placeholderClassname}
      isFocus={isFocus}
      setIsFocus={setIsFocus}
    >
      <PasswordFiled
        withPlaceholder={false}
        ref={inputRef}
        value={value}
        onBlur={handleBlur}
        onFocus={handleFocus}
        rootClassName={`hideAutoFillBtn passwordInput px-0 py-0 !border-none rounded-[0px] !shadow-none focus:shadow-none focus:border-none w-full ${className}`}
        {...props}
      />
    </CustomInput>
  )
}

export default CustomPasswordFiled
